import type { MouseEvent } from 'react';

/** Follow the link with the piece's action, so a plain click stays in the site. */
export function onLink(open: () => void) {
  return (e: MouseEvent) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open();
  };
}
